import { forwardRef } from 'react'
import { NavLinkProps, NavLink as RouterNavLink } from 'react-router-dom'

import cx from 'clsx'

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(({ className, children, ...rest }, ref) => (
  <RouterNavLink ref={ref} {...rest} className={({ isActive }) => cx(className, { 'Mui-selected': isActive })}>
    {children}
  </RouterNavLink>
))
